<div class="pl-4 pr-4 flex flex-column h-full" *ngIf="user!=null && chatRoom!=null">
    <div *ngIf="case!=null" class="chat-messages flex flex-column gap-2 mb-4">
        <div><b>Expediente:</b> <a [routerLink]="['/cases', case?.id]" target="_blank">{{case?.caseNumber}}</a></div>
        <div><b>Asegurado:</b> {{case?.client?.name}}</div>
        <div><b>Dirección:</b> {{case?.client?.address?.fullAddress}}</div>
    </div>
    <div class="flex justify-content-end mb-2">
        <p-button (click)="markAsRead()" icon="pi pi-check" label="Leído" styleClass="h-full" />
    </div>
    <div #chatMessages class="chat-messages flex-grow-1">
        <div *ngFor="let message of messages" [class.chat-message-left]="user.id!=message.createdBy" [class.chat-message-right]="user.id==message.createdBy">
            <div class="chat-message">
                <div class="message-info">
                    <i *ngIf="message.isImportant" class="pi pi-exclamation-circle text-danger"></i>
                    <span class="date">{{message.createdAt | date:'dd/MM/yyyy HH:mm:ss'}}</span>
                    <span class="user-name">{{message.createdByUser?.name}}</span>
                </div>
                <div class="message">{{message.message}}</div>
            </div>
        </div>
        <div *ngIf="messages.length==0">
            Todavía no hay mensajes
        </div>
    </div>
    <div class="mt-4 flex gap-2 align-items-end">
        <div class="relative flex-grow-1">
            <textarea pInputTextarea [autoResize]="true" rows="1" placeholder="Escribe tu mensaje" [(ngModel)]="message"
                class="w-full chat-message-input" [style.max-height.px]="150" (keydown)="onEnter($event)"></textarea>
            <a class="button-important pi pi-exclamation-circle" (click)="isImportant=!isImportant" [class.text-danger]="isImportant"></a>
        </div>
        <p-button (click)="sendMessage()" icon="pi pi-send" />
    </div>
</div>
<div class="pl-4 pr-4 flex flex-column h-full" *ngIf="user==null || chatRoom==null">
    <div *ngIf="user==null">
        Usuario no identificado correctamente
    </div>
    <div *ngIf="chatRoom==null">
        Cargando sala, por favor espere...
    </div>
</div>